/**
 * Defaults to Tote mode. User can switch between:
 *   TOTE    -> ToteScannerView (scans tote barcode -> tote items flow)
 *   PRODUCT -> ProductScannerView (scans product barcode -> classification flow)
 */

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ToteScannerView from "./ToteScannerView";
import ProductScannerView from "./ProductScannerView";
import { ScanMode } from "./ScannerSharedComponents";

export interface ScannerPageLocationState {
  title?: string;
  mode?: string;
}

const ScannerPage: React.FC = () => {
  const location = useLocation();
  const { title, mode } = (location.state as ScannerPageLocationState) ?? {};
  const [activeMode, setActiveMode] = useState<ScanMode>(
    mode === "PRODUCT" ? ScanMode.PRODUCT : ScanMode.TOTE,
  );

  if (activeMode === ScanMode.TOTE) {
    return <ToteScannerView activeMode={activeMode} onModeChange={setActiveMode} />;
  }

  return <ProductScannerView activeMode={activeMode} onModeChange={setActiveMode} title={title} />;
};

export default ScannerPage;
